import React from "react";

const SellerCategoryContext = React.createContext();

export default SellerCategoryContext;